module.exports = __webpack_public_path__ + "static/media/Kyash.6495e9ad.svg";